(function($) {

    var thematicToggler = $(".thematic-toggler");
    var thematicsList = $("#facetcategories");

// Ouverture Filtres "Filtrer par matière"
    thematicToggler.click(function(event) {

        $(this).toggleClass("thematic-toggler--opened");

        if($(this).attr("aria-expanded") === "true") {
            $(this).attr("aria-expanded", "false")
        } else {
            $(this).attr("aria-expanded", "true")
        }

        thematicsList.toggleClass("list-group--opened");
    })
})(jQuery);
